// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {BaseSelect} from "@/components";
import {adapterBankWithAccount, findBankData, getDataFromAccount} from "../../../../adapters/bankListAdapter";
import useGetAccountPagoMovil from "../../../../hooks/wallet/useGetAccountPagoMovil";
import {useBalanceStore} from "../../../../store/useBalance.store";
import WithdrawalLimits from "./WithdrawalLimits";

const SelectAccount = ({setSelectBankAccount, setIsNextDisabled}) => {
  const {data} = useGetAccountPagoMovil();
  const [accountId, setAccountId] = useState("");
  const handlePagoMovilListModal = useBalanceStore.getState().handlePagoMovilListModal;
  const isMobile = window.innerWidth <= 768;
  const {t} = useTranslation();

  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  useEffect(() => {
    if (accountId) {
      const bankSelected = getDataFromAccount(data, accountId);
      if (bankSelected) {
        const bankName = findBankData(bankSelected).bank_name;
        setSelectBankAccount({
          id: bankSelected.ID,
          phone: bankSelected.phone_number,
          bankCode: bankSelected.bank_code,
          bankName,
        });
      }
    }
  }, [accountId, data, setSelectBankAccount]);

  const handleChange = e => {
    setAccountId(e.target.value);
    setIsNextDisabled?.(false);
  };

  const options = data ? adapterBankWithAccount(data) : [];

  return (
    <div>
      <WithdrawalLimits />
      <div style={{marginTop: 16}}>
        <h4
          style={{
            fontWeight: 700,
            textAlign: "center",
            fontSize: isMobile ? 16 : undefined,
          }}
        >
          {t("withdrawalStepsSelectAccount")}
        </h4>
        {isMobile ? (
          <div style={{marginBottom: "var(--space-4-5)"}}>
            <BaseSelect
              placeholder={t("withdrawalStepsSelectAccount_select")}
              value={accountId}
              onChange={handleChange}
              options={options}
              showSearch
              className="mobile-bank-select"
            />
          </div>
        ) : (
          <div style={{display: "flex", alignItems: "center", marginBottom: "var(--space-4-5)"}}>
            <h4 style={{fontWeight: 500, marginRight: "var(--space-3)", minWidth: 90}}>
              {t("withdrawalStepsSelectTitle")}:
            </h4>
            <div style={{flex: 1}}>
              <BaseSelect
                placeholder={t("withdrawalStepsSelectAccount_select")}
                value={accountId}
                onChange={handleChange}
                options={options}
                showSearch
                className="select-bottom-line"
              />
            </div>
          </div>
        )}

        <h4 style={{fontSize: isMobile ? 16 : undefined}}>
          {t("withdrawalStepsSelectAccountDesc2")}
          <button
            type="button"
            style={{
              cursor: "pointer",
              color: "var(--color-primary)",
              background: "transparent",
              border: "none",
              padding: 0,
              font: "inherit",
            }}
            onClick={() => handlePagoMovilListModal()}
          >
            {t("withdrawalStepsSelectAccountlink")}
          </button>
          .
        </h4>
      </div>
    </div>
  );
};

SelectAccount.propTypes = {
  setSelectBankAccount: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default SelectAccount;
